const textDecorationLine = {
  name: "text-decoration-line",
  path: "/text-decoration-line",
  title: "text-decoration-line",
  description: "Utilities for controlling the text decoration line of an element.",
  value: {
    "text-decoration-line": {
      "underline": "underline",
      "line-through": "line-through",
      "no-underline": "none",
      "overline": "overline"
    }
  },
  exampleData: [
    {
      example: {
        code: `
<p class="underline">This text is underlined.</p>
<p class="line-through">This text is line-through.</p>
<p class="overline">This text is overlined.</p>
<p class="no-underline">This text has no decoration.</p>
        `
      }
    }
  ],
  htmlData: [
    {
      data: `
      <p class="text-color-gray-600 text-sm dark:text-color-gray-300 mb-10">
        Use <code class="text-color-gray-800 dark:text-color-white font-semibold">underline</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">line-through</code>, <code class="text-color-gray-800 dark:text-color-white font-semibold">overline</code>, or <code class="text-color-gray-800 dark:text-color-white font-semibold">no-underline</code> to control text decoration line.
      </p>
      <div class="space-y-6">
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">underline</small>
          <p class="underline text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">line-through</small>
          <p class="line-through text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">overline</small>
          <p class="overline text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
        <div>
          <small class="mb-3 font-mono font-medium text-color-gray-500 dark:text-color-gray-400">no-underline</small>
          <p class="no-underline text-lg">The quick brown fox jumps over the lazy dog.</p>
        </div>
      </div>
      `
    }
]
}
export default textDecorationLine;
<div className="underline line-through overline no-underline sr-only"></div>